import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const FilterButtons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 16px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      margin-top: 16px;
      flex-direction: column-reverse;
      align-items: center;
    }
  `}
`
